import { Component, Input, Output, EventEmitter, OnInit, Inject, LOCALE_ID, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ActionCoAction, ActionCoArticleFacturation, ActionCoCardModel, ActionCoContact, ActionCoDevis, ActionCoDevisModel, ActionCoEntiteGroupFacturation, ActionCoFormation, ActionCoFormationList, ActionCoGroupFacturation, ActionCoHistory, ActionCoHistoryType, ActionCoLigneDevis, ActionCoLigneDevisOption, ActionCoParcours, ActionCoSessionStage, ActionCoTypeDevis, BObjectModel, CRUD, FileModel, Person, QueovalDate, QueovalDateTime, QueovalItem, Select } from '../../../models';
import { HttpService, CoreService, QueovalDateService, FilesManagerService } from '../../../services';
import * as _ from 'lodash';
import { ToastService } from '../../../toast';
import { GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionCoService } from '../action-co-services/action-co.service';
import { HistoryService } from '../../../history';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-devis',
  templateUrl: './action-co-devis.component.html',
  styleUrls: ['./action-co-devis.component.css', '../action-co-card.component.css', '../action-co-action/action-co-action.component.css',]
})

export class ActionCoDevisComponent implements OnInit {

  constructor(
    protected http: HttpService,
    protected indParam: CoreService,
    protected qDateService: QueovalDateService,
    public toast: ToastService,
    private modalService: NgbModal,
    private fileService: FilesManagerService,
    @Inject(LOCALE_ID) public locale: string,
    public actionCoService: ActionCoService,
    protected historyService: HistoryService
  ) { }

  @ViewChild('closeModalInsertDoc') closeModalInsertDoc: ElementRef<HTMLButtonElement>;

  @Output() setIdActionCo: EventEmitter<string> = new EventEmitter<string>();

  public model: ActionCoDevisModel = new ActionCoDevisModel();

  public modeBo: string = '';
  public IdContact: string;
  public IdContactPrincipal: string;
  public Loaded: boolean = false;
  public LoadedDevis: boolean = false;
  public LoadedCatalogue: boolean = false;
  public CRUD = CRUD;
  public TempLigne: ActionCoLigneDevis;
  public EditingOption: number;
  public EditingLigne: number;
  public Newline: boolean = false;
  public Editing: boolean = false;
  public SaveInprogress: boolean = false;

  public selectParcoursDevis: string;
  public QuantiteParcours: number = 1;

  public FormationDefault: ActionCoFormation | undefined;

  public HistoryBoTypes: Array<Select> = new Array<Select>();
  public ThumbBoTypeValue: string = '';

  public clickedThumb: string = '';

  public insertDocModel: BObjectModel;

  // Filtre de la datagrid
  public filterStageCycles: string = '';
  public filterStageTypes: string = '';
  public NumeroStage: string = '';
  public TitreStage: string = '';
  public filterStage: string = '';


  public refreshData: boolean = false;
  public devisAwaitingGeneration: boolean = false;

  public mainContact: boolean = false;

  public listAction: Array<ActionCoAction> = new Array<ActionCoAction>();

  public listTypesStage: Array<Select>;

  public ngOnInit(): void {

    this.listTypesStage = new Array<Select>({ id: '', value: 'Filtre sur type' }, { id: 'INTER', value: 'INTER' }, { id: 'SESSION', value: 'SESSION' })
    this.filterStage = '';
    this.filterStageCycles = '';
    this.filterStageTypes = '';

    this.actionCoService.ContactAdd$.subscribe((bool: Boolean) => {
      this.GetListeContacts();
    });

    if (!this.actionCoService.Model.idActionCo || this.actionCoService.Model.idActionCo == '' || this.actionCoService.Model.idActionCo == '0') {
      this.Loaded = false;
      this.LoadedDevis = false;
      this.LoadedCatalogue = false;
      return;
    }

    // Liste des stages rattaches aux produits ou aux actions
    this.selectParcoursDevis = this.actionCoService.Model.TypeDevis != ActionCoTypeDevis.Devis ? "selectParcoursDevisProduit" : "selectParcoursDevisAction";



    // Chargement des listes combo
    this.http.getHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis/INIT/${this.actionCoService.Model.idActionCo}/`).subscribe((dataInit: ActionCoDevisModel) => {
      if (!dataInit.HasError) {
        this.model = dataInit;
        if (this.actionCoService.Model.TypeDevis != ActionCoTypeDevis.Devis) {
          // Type de tarif
          if (this.model.ListTypeTarif.length > 0)
            this.model.SelectedTarif = this.model.ListTypeTarif[0].id;
        }

        // Chargement actionco projet devis lignes
        this.actionCoService.GetInfoDevis(this.model).subscribe((data: ActionCoDevisModel) => {
          if (!data.HasError) {

            data.ActionCoFormation = this.model.ActionCoFormation;
            data.ActionCoTypeFormation = this.model.ActionCoTypeFormation;
            this.model = data;

            this.initBoInsertDoc();

            //Selection automatique du commerical
            if (!this.model.Devis.IdCommercial || this.model.Devis.IdCommercial == '' || this.model.Devis.IdCommercial == '0') {
              this.model.Devis.IdCommercial = this.actionCoService.Model.IdCollabo;
              this.model.Devis.PhotoCommercial = this.actionCoService.Model.LogoCollabo;
              this.model.Devis.NameCommercial = this.actionCoService.Model.NameCollabo;
            } else {
              const collabActionCo: any = this.actionCoService.Model.Collaborateurs.find((collab: Person) => { return collab.Id == this.model.Devis.IdCommercial })
              if (collabActionCo) {
                this.model.Devis.PhotoCommercial = collabActionCo.ProfilePicture;
                this.model.Devis.NameCommercial = `${collabActionCo.Firstname} ${collabActionCo.Lastname}`;
              }
            }

            //Selection automatique du contact principal de l'action co
            if (!this.model.Devis.Ident || this.model.Devis.Ident == '' || this.model.Devis.Ident == '0') {
              const cntActionCo: any = this.model.ListContactPrincipal.find((cnt: ActionCoContact) => { return cnt.id == this.actionCoService.Model.ContactPrincipal.Id });
              if (cntActionCo) {
                cntActionCo.selected = true;
              }
            }

            // Nombre de contact selectionne
            this.QuantiteParcours = 0;
            //this.model.ListContactPrincipal.forEach(cnt => { if (cnt.selected) this.QuantiteParcours++; });
            this.model.ListContact.forEach(cnt => { if (cnt.selected) this.QuantiteParcours++; });

            this.LoadedDevis = true;
          }
        });

        // Chargement du catalogue : Action ou Produit 
        dataInit.Mode = 'CATALOGUE';
        this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, dataInit).subscribe((data: ActionCoDevisModel) => {
          if (!data.HasError) {
            this.model.ActionCoFormation = data.ActionCoFormation;
            this.model.ActionCoTypeFormation = data.ActionCoTypeFormation;
            this.FormationDefault = this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Code == 'DEFAULT' });

            this.LoadedCatalogue = true;
          }
        });

        this.Loaded = true;
      }
    });
  }

  // Region Visualisation BO projet et devis
  public OnOpenBo(type: string, mainContact: boolean = false) {
    this.mainContact = mainContact;
    this.modeBo = type;
  }

  public OnCloseBo(value: any) {
    if (value && value.Value === 'RELOAD') {
      if (this.modeBo === 'DEVIS') {
        // this.model.Mode = 'INITDEVIS';
        this.actionCoService.GetInfoDevis(this.model).subscribe((data: ActionCoDevisModel) => {
          // this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
          if (!data.HasError) {
            data.ActionCoFormation = this.model.ActionCoFormation;
            data.ActionCoTypeFormation = this.model.ActionCoTypeFormation;
            this.model = data;
            this.actionCoService.CanTransform();
            this.actionCoService.OnDevisSigned(data.Devis.DevisSigne);
          }
        });
        this.actionCoService.OnDocumentDevis();
      }
    }
    if (this.modeBo === 'CONTACT') {
      this.model.Mode = 'CONTACTS';
      this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
        if (!data.HasError) {

          const newResp = data.ListContactPrincipal.find(x => x.id == value.Value);
          if (newResp) {
            newResp.selected = this.mainContact;
            this.model.ListContactPrincipal.push(newResp);
          }

          const newContact = data.ListContact.find(x => x.id == value.Value);
          if (newContact) {
            if (!newResp || !this.mainContact) {
              newContact.selected = true;
            }
            this.model.ListContact.push(newContact);
          }

          // Nombre de contact selectionne
          this.QuantiteParcours = this.model.ListContact.filter(x => x.selected).length;
        }
      });
    }
    this.modeBo = '';

  }
  // EndRegion Visualisation BO projet et devis


  // Region Gestion stage inter et session 

  public OnCycleChange(value: string) {
    if (value == '')
      this.filterStageCycles = ''
    else
      this.filterStageCycles = `CY.Ident =  ${value}`;

    this.filterStage = this.filterStageCycles;
    this.filterStage = this.filterStage == '' ? this.filterStageTypes : this.filterStageTypes != '' ? `${this.filterStage} AND ${this.filterStageTypes}` : this.filterStage;
    this.refreshData = true;
  }

  public OnTypesChange(value: string) {
    if (value == '')
      this.filterStageTypes = ''
    else
      this.filterStageTypes = `S.TypsoPRO =  '${value}'`;

    this.filterStage = this.filterStageTypes;
    this.filterStage = this.filterStage == '' ? this.filterStageCycles : this.filterStageCycles != '' ? `${this.filterStage} AND ${this.filterStageCycles}` : this.filterStage;

    this.refreshData = true;
  }

  public OnTarifChange(value: string) {
    this.model.SelectedTarif = value;
  }

  public OnSaveParcoursDevis() {

    if (this.model.ListActionCoParcours && this.model.ListActionCoParcours.length > 0) {

      this.model.ListActionCoParcours.forEach(parcours => { parcours.Quantite = this.QuantiteParcours; });


      this.Editing = true;
      this.model.Mode = 'LIGNEDEVISAUTO';
      this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
        if (!data.HasError) {
          this.LoadedDevis = false;
          // this.model.Mode = 'INITDEVIS';
          this.actionCoService.GetInfoDevis(this.model).subscribe((data: ActionCoDevisModel) => {
            if (!data.HasError) {
              data.ListContact = this.model.ListContact;
              data.ListContactPrincipal = this.model.ListContactPrincipal;
              data.ActionCoFormation = this.model.ActionCoFormation;
              data.ActionCoTypeFormation = this.model.ActionCoTypeFormation;
              this.model = data;
              this.actionCoService.CanTransform();
              this.LoadedDevis = true;
            }
          });
          this.actionCoService.OnDocumentDevis();
        }
        this.Editing = false;
      });
    }
    this.OnCancelParcoursDevis();
  }

  public OnCancelParcoursDevis() {
    this.filterStage = '';
    this.filterStageCycles = '';
    this.filterStageTypes = '';
    this.modeBo = '';
  }

  public OnSelectParcoursChange(event: SelectionChangedEvent) {
    // liste des items selectionnes
    const listItem: any[] = event.api.getSelectedRows();
    this.model.ListActionCoParcours = new Array<ActionCoParcours>();
    if (listItem) {
      listItem.forEach(item => {
        const parcours: ActionCoParcours = new ActionCoParcours();
        parcours.IdCatalogue = item["idCatalogue"];
        parcours.IdAction = item["idProduit"];
        parcours.IdSession = "0";
        parcours.IdStage = item["idStage"];
        parcours.IdReservation = item["idReserv"];
        parcours.TypeStage = item["typeStage"];
        parcours.PrixUnitaire = item["montant"];
        parcours.Quantite = this.QuantiteParcours;
        this.model.ListActionCoParcours.push(parcours);
      })
    }
  }

  // EndRegion Gestion stage inter et session

  // Region ng-modal
  public openUploadDocument(content: any) {
    this.modalService.open(content, { size: 'xl', windowClass: 'qmodalover', centered: true }).result.then((result) => {
      switch (result) {
        case 'SAVE': this.model.Devis.FileExist = true; break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }

  public openDeleteAllLigne(content: any) {
    this.modalService.open(content, { size: 'xl', windowClass: 'qmodalover', centered: true }).result.then((result) => {
      switch (result) {
        case 'DELETE': this.DeleteAllLigne(); break;
        case 'CANCEL': break;
      }
    });
  }

  // EndRegion ng-modal

  public open(popover: any, ligne: ActionCoLigneDevis) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({ ligne });
    }
  }

  public GetListeContacts(): void {

    this.model.Mode = 'CONTACTS';
    this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
      if (!data.HasError) {
        this.model.ListContactPrincipal = data.ListContactPrincipal;
        this.model.ListContact = data.ListContact;

        //Selection automatique du contact principal de l'action co
        if (!this.model.Devis.Ident || this.model.Devis.Ident == '' || this.model.Devis.Ident == '0') {
          const cntActionCo: any = this.model.ListContactPrincipal.find((cnt: ActionCoContact) => { return cnt.id == this.actionCoService.Model.ContactPrincipal.Id });
          if (cntActionCo) {
            cntActionCo.selected = true;
          }
        }
        // Nombre de contact selectionne
        this.QuantiteParcours = 0;
        //this.model.ListContactPrincipal.forEach(cnt => { if (cnt.selected) this.QuantiteParcours++; });
        this.model.ListContact.forEach(cnt => { if (cnt.selected) this.QuantiteParcours++; });
      }
    });
  }

  public GetContact(selected: QueovalItem, type: string): void {
    switch (type) {
      case 'Contact':
        this.IdContact = selected.Value;
        break;
      case 'ContactPrincipal':
        this.IdContactPrincipal = selected.Value;
        break;
    }
  }
  public AddCnt(element: ActionCoContact): void {
    element.selected = true;
    this.QuantiteParcours = 0;
    this.model.ListContact.forEach(cnt => { if (cnt.selected) this.QuantiteParcours++; });
  }
  public RemoveCnt(element: ActionCoContact): void {
    element.selected = false;
    this.QuantiteParcours = 0;
    this.model.ListContact.forEach(cnt => { if (cnt.selected) this.QuantiteParcours++; });
  }
  public CheckListCnt(ListContact: Array<any>, selected: boolean = true): boolean {
    return selected ? ListContact.some(cnt => cnt.selected) : ListContact.some(cnt => !cnt.selected);
  }


  public GetActionList(IdentFormation: string) {
    let formation: any = this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == IdentFormation });
    return formation ? formation.ListAction : new Array<ActionCoAction>();
  }
  public GetSessionList(IdentFormation: string, IdentAction: string) {
    if (IdentAction) {
      let formation: any = this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == IdentFormation });
      let action: any = formation ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == IdentAction }) : null;
      return action ? action.ListSessionStage : new Array<ActionCoSessionStage>();
    } else {
      return new Array<ActionCoSessionStage>();
    }
  }
  public GetGroupFacturation(IdentEntite: string) {
    if (IdentEntite) {
      let entite: any = this.model.ListEntiteFacturation.find((acrgf: ActionCoEntiteGroupFacturation) => { return acrgf.id == IdentEntite });
      return entite.ListGroupFacturation;
    } else {
      return null;
    }
  }

  public GetInfoArticle(IdentEntite: string, IdentGroup: string, IdentArticle: string): ActionCoArticleFacturation {
    if (IdentEntite && IdentGroup && IdentArticle) {
      let entite: any = this.model.ListEntiteFacturation.find((acegf: ActionCoEntiteGroupFacturation) => { return acegf.id == IdentEntite });
      let group: any = entite.ListGroupFacturation.find((acgf: ActionCoGroupFacturation) => { return acgf.id == IdentGroup });
      let article: any = group.ListArticle.find((acaf: ActionCoArticleFacturation) => { return acaf.id == IdentArticle });
      return article;
    } else {
      return new ActionCoArticleFacturation();
    }
  }

  public CalcMontant(ligne: ActionCoLigneDevis) {
    if (ligne.Quantite && ligne.PrixUnitaire) {
      ligne.MontantHT = ligne.PrixUnitaire * ligne.Quantite;
      if (ligne.Remise != 0) {
        if (ligne.TypeRemise.id == 'POURCENT') {
          ligne.MontantHT -= ligne.MontantHT * ligne.Remise / 100;
        } else if (ligne.TypeRemise.id == 'MONTANT') {
          ligne.MontantHT -= ligne.Remise;
        }
      }
      ligne.MontantTTC = ligne.MontantHT + ligne.MontantHT * parseFloat(ligne.TauxTVA.id) / 100;
    } else {
      ligne.MontantHT = 0;
    }
  }

  public BuildDate(value: QueovalDate): string {
    return this.qDateService.ToString(value, 'dd/MM/yyyy');
  }


  // Collaborateur sur le devis
  public OnCollaboChange(Collabo: Array<Person>): void {
    if (Collabo && Collabo.length) {
      const collabo: Person = Collabo[0];
      this.model.Devis.IdCommercial = collabo.Id;
      this.model.Devis.PhotoCommercial = collabo.ProfilePicture;
      this.model.Devis.NameCommercial = collabo.Value;
    }
  }

  public SelectChange(value: any, mode: string) {
    switch (mode) {
      case 'ENTITEFACTURATION': this.setEntiteFacturation(value); break;
      case 'GROUPEFACTURATION': this.setGroupeFacturation(value); break;

      case 'TYPEDOC': this.setTypeDoc(value); break;
      case 'DOSSIER': this.SetDossier(value); break;
      case 'LIGNEACTION': this.setLigneAction(value); break;
      case 'LIGNESESSION': this.setLigneSession(value); break;
      case 'LIGNEGROUP': this.setLigneGroup(value); break;
      case 'LIGNEARTICLE': this.setLigneArticle(value); break;
      case 'LIGNETAUXTVA': this.setLigneTauxTVA(value); break;
      case 'LIGNETYPEREMISE': this.setLigneTypeRemise(value); break;
      case 'LIGNEUNITE': this.setLigneUnite(value); break;
    }
  }

  private initBoInsertDoc(): void {
    this.insertDocModel = new BObjectModel();
    this.insertDocModel.IdDonneeFils = this.model.Devis.Ident;
    this.insertDocModel.IdRelation = "REL_BO_CSOC_BO_DEVIS";
  }

  /*Select entite et groupe de facturation*/
  private setEntiteFacturation(idEntite: any) {
    this.model.Project.entite.id = idEntite;
    this.model.Project.group.id = '0';
  }
  private setGroupeFacturation(idGroup: any) {
    this.model.Project.group.id = idGroup;
  }
  /*Select type modele devis*/
  private setTypeDoc(idTypeDoc: any) {
    const typeDoc: any = this.model.ListTypeDoc.find((typeDoc: Select) => typeDoc.id == idTypeDoc);
    this.model.Devis.TypeDoc = typeDoc;
  }
  private SetDossier(idDossier: any) {
    const typeDossier: any = this.model.ListDossierDevis.find((dossierDev: Select) => dossierDev.id == idDossier);
    if (typeDossier)
      this.model.Devis.Dossier = typeDossier;
    else
      this.model.Devis.Dossier = new Select();
  }
  /*Select ligne devis*/
  private setLigneAction(idAction: any) {
    let ligne: ActionCoLigneDevis = this.EditingOption > -1 ?
      this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] :
      this.model.CRUDActionCoLigneDevis;
    const formation: any = this.model.ActionCoFormation ? this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation }) : null;
    const action: any = formation && formation.ListAction ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == idAction }) : null;

    let articleInfo: ActionCoArticleFacturation = this.GetInfoArticle(this.model.Project.entite.id, this.model.Project.group.id, action.Article.id);
    articleInfo = articleInfo ? articleInfo : action ? action.Article : new ActionCoArticleFacturation();
    ligne.Article = articleInfo;
    ligne.GroupOption = action ? action.GroupOption : new Select();
    ligne.PrixUnitaire = articleInfo.isBareme ? 0 : action ? action.PrixUnitaire : 0;
    ligne.TauxTVA = articleInfo.tauxTVA && articleInfo.tauxTVA.id ? articleInfo.tauxTVA : action ? action.TauxTVA : new Select();
    ligne.Unite = action ? action.Unite : new Select();
    ligne.Quantite = action ? action.Quantite : 1;

    ligne.Designation = action ? action.Description : '';
    ligne.IntituleAction = action ? action.Intitule : '';
    ligne.IdentAction = idAction;
    ligne.SessionStage = new ActionCoSessionStage();
    ligne.SessionStage.Ident = '0';

    ligne.DureeHeure = action ? action.DureeHeure : 0;
    ligne.DureeJour = action ? action.DureeJour : 0;

    this.CalcMontant(ligne);
  }


  private setLigneSession(idSession: any) {
    let ligne: ActionCoLigneDevis = this.EditingOption > -1 ?
      this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] :
      this.model.CRUDActionCoLigneDevis;
    const formation: any = this.model.ActionCoFormation ? this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation }) : null;
    const action: any = formation && formation.ListAction ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == ligne.IdentAction }) : null;
    const session: ActionCoSessionStage = action && action.ListSessionStage ? action.ListSessionStage.find((acs: ActionCoSessionStage) => { return acs.Ident == idSession }) : null;


    if (session.DureeHeure) {
      ligne.DureeHeure = session.DureeHeure;
    } else {
      ligne.DureeHeure = action.DureeHeure;
    }
    ligne.IntituleSession = session ? session.Intitule : '';
    ligne.SessionStage = session ? session : new ActionCoSessionStage();
  }
  private setLigneGroup(idGroup: any) {
    const grp: any = this.model.ListGroupOption.find((grp: Select) => grp.id == idGroup);
    let ligne: ActionCoLigneDevis = this.EditingOption > -1 ?
      this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] :
      this.model.CRUDActionCoLigneDevis;
    ligne.GroupOption = grp;
  }
  private setLigneArticle(idArticle: any) {
    /*  let ligne: ActionCoLigneDevis = this.EditingOption > -1 ?
        this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] :
        this.model.CRUDActionCoLigneDevis;
      ligne.Article.id == idArticle;*/
  }
  private setLigneTauxTVA(idTxTVA: any) {
    const txTva: any = this.model.ListTauxTVA.find((tva: Select) => tva.id == idTxTVA);
    let ligne: ActionCoLigneDevis = this.EditingOption > -1 ?
      this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] :
      this.model.CRUDActionCoLigneDevis;
    ligne.TauxTVA = txTva;
    this.CalcMontant(ligne);
  }
  private setLigneTypeRemise(idRemise: any) {
    const remise: any = this.model.ListTypeRemise.find((remise: Select) => remise.id == idRemise);
    let ligne: ActionCoLigneDevis = this.EditingOption > -1 ?
      this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] :
      this.model.CRUDActionCoLigneDevis;
    ligne.TypeRemise = remise;
    this.CalcMontant(ligne);
  }
  private setLigneUnite(idUnite: any) {
    const unite: any = this.model.ListUnite.find((unite: Select) => unite.id == idUnite); let ligne: ActionCoLigneDevis = this.EditingOption > -1 ?
      this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] :
      this.model.CRUDActionCoLigneDevis;
    ligne.Unite = unite;
  }

  //#Region gestion de l'ordre des lignes et des groupes options
  public changeOrderOption(indexOption: number, option: ActionCoLigneDevisOption): void {

    this.Editing = true;

    this.model.ListActionCoLigneDevisOption[indexOption - 1].OrderOption = indexOption;
    this.model.ListActionCoLigneDevisOption.splice(indexOption, 1);
    this.model.ListActionCoLigneDevisOption.splice(indexOption - 1, 0, option);
    this.model.ListActionCoLigneDevisOption[indexOption - 1].OrderOption = indexOption - 1;

    this.ReOrderLigneEtOption();


  }

  public changeOrderLine(indexLine: number, lines: ActionCoLigneDevis): void {

    let groupe: ActionCoLigneDevisOption | undefined = this.model.ListActionCoLigneDevisOption.find(option => option.CodeOption == lines.GroupOption.id);
    if (groupe != undefined) {
      this.Editing = true;

      groupe.ListActionCoLigneDevis[indexLine - 1].OrdreLigne = indexLine;
      groupe.ListActionCoLigneDevis.splice(indexLine, 1);
      groupe.ListActionCoLigneDevis.splice(indexLine - 1, 0, lines);
      groupe.ListActionCoLigneDevis[indexLine - 1].OrdreLigne = indexLine - 1;

      this.ReOrderLigneEtOption();
    }

  }

  private ReOrderLigneEtOption(): void {

    this.Editing = true;

    //Mise à jour de l'ordre sur la liste des lignes et sur les options
    this.model.ListActionCoLigneDevisOption.forEach((option: ActionCoLigneDevisOption, indexOpt: number) => {
      option.OrderOption = indexOpt;
      option.ListActionCoLigneDevis.forEach((ligne: ActionCoLigneDevis, indexLng: number) => { ligne.OrdreLigne = indexOpt * 1000 + indexLng; });
    });


    this.model.Mode = 'UPDATEORDRELIGNEDEVIS';
    this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
      this.Editing = false;
    });
  }

  //#Endregion gestion de l'ordre des lignes et des groupes options

  public GetInfoAction(ligne: ActionCoLigneDevis): string {
    if (this.model.ActionCoFormation) {
      const formation: any = this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation });
      const action: any = formation ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == ligne.IdentAction }) : null;
      return action ? action.InfoInterne ? `Produit: ${action.Intitule} (${action.Code}) - Info interne: ${action.InfoInterne}` : `Produit: ${action.Intitule} (${action.Code})` : '';
    } else {
      return '';
    }

  }

  public GetInfoInterneAction(ligne: ActionCoLigneDevis): string {
    if (this.model.ActionCoFormation) {
      const formation: any = this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation });
      const action: any = formation ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == ligne.IdentAction }) : null;
      return action && action.InfoInterne ? action.InfoInterne : '';
    } else {
      return '';
    }
  }

  public GetAction(ligne: ActionCoLigneDevis): string {
    if (!ligne.IntituleAction) {
      if (this.model.ActionCoFormation) {
        const formation: any = this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation });
        const action: any = formation ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == ligne.IdentAction }) : null;
        ligne.IntituleAction = action ? action.Intitule : '';
      }
      else {
        ligne.IntituleAction = '';
      }
    }
    return ligne.IntituleAction;
  }

  public GetInfoSession(ligne: ActionCoLigneDevis): string {
    if (this.model.ActionCoFormation) {
      const formation: any = this.model.ActionCoFormation ? this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation }) : null;
      const action: any = formation ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == ligne.IdentAction }) : null;
      const session: any = action && action.ListSessionStage && ligne.SessionStage ? action.ListSessionStage.find((acs: ActionCoSessionStage) => { return acs.Ident == ligne.SessionStage.Ident }) : null;
      return session ? session.Information : ligne.Information ? ligne.Information : '';
    } else {
      return '';
    }
  }

  public GetSession(ligne: ActionCoLigneDevis): string {
    if (!ligne.IntituleSession) {
      if (this.model.ActionCoFormation) {
        const formation: any = this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation });
        const action: any = formation ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == ligne.IdentAction }) : null;
        const session: any = action && action.ListSessionStage && ligne.SessionStage ? action.ListSessionStage.find((acs: ActionCoSessionStage) => { return acs.Ident == ligne.SessionStage.Ident }) : null;
        ligne.IntituleSession = session ? session.Intitule : ligne.SessionStage ? ligne.SessionStage.Intitule : '';
        ligne.SessionStage = session ? session : ligne.SessionStage ? ligne.SessionStage : new ActionCoSessionStage();
      }
      else {
        ligne.SessionStage = new ActionCoSessionStage();
      }

    }
    return ligne.IntituleSession;
  }

  public GetDateSession(ligne: ActionCoLigneDevis): string {

    const formation: any = this.model.ActionCoFormation ? this.model.ActionCoFormation.find((acf: ActionCoFormation) => { return acf.Ident == ligne.IdentFormation }) : null;
    if (formation.TypeFormation.id.toUpperCase() != 'CONVENTION')
      return '';
    // Information des reservation uniquement pour Formation ayant Segmentation Devis => CONVENTION
    const action: any = formation ? formation.ListAction.find((aca: ActionCoAction) => { return aca.Ident == ligne.IdentAction }) : null;
    let session: any = action && action.ListSessionStage && ligne.SessionStage ? action.ListSessionStage.find((acs: ActionCoSessionStage) => { return acs.Ident == ligne.SessionStage.Ident }) : null;
    let isExpired: boolean = false;
    if (!session && ligne.SessionStage) {
      session = ligne.SessionStage;
      isExpired = this.qDateService.IsNull(ligne.SessionStage.DateDebut) ? false : this.qDateService.Compare(ligne.SessionStage.DateDebut, '<', this.qDateService.Now());
    }

    let dateSession: string = '';
    if (session) {
      if (!this.qDateService.IsNull(session.DateDebut)) {

        let typeSession: string = session.IdentEvenement != '0' ? 'Réservation' : session.IdentStage != '0' ? `Stage n°${session.NumeroStage}` : '';
        if (isExpired)
          typeSession = session.IdentEvenement != '0' ? 'Réservation expirée' : session.IdentStage != '0' ? `Stage expiré n°${session.NumeroStage}` : '';

        dateSession = `${typeSession} du ${this.BuildDate(session.DateDebut)}`;
        if (!this.qDateService.IsNull(session.DateFin) && !this.qDateService.Compare(session.DateDebut, '=', session.DateFin))
          dateSession = `${typeSession} du ${this.BuildDate(session.DateDebut)} au ${this.BuildDate(session.DateFin)}`;

        if (session.IdentEvenement != '0')
          dateSession = `${dateSession}  (${session.NumeroStage})`;
      }
      else if (session.IdentSession != '0' && session.IdentSession != '') {
        dateSession = `Catalogue`;
      }
    }

    return dateSession;
  }

  public GetOptionInfoSession(session: ActionCoSessionStage): string {
    let infoSession: string = '';
    if (session) {
      if (!this.qDateService.IsNull(session.DateDebut)) {
        const typeSession: string = session.IdentEvenement != '0' ? 'Réservation' : session.IdentStage != '0' ? 'Stage' : '';
        infoSession = `${session.Intitule} ( ${typeSession} du ${this.BuildDate(session.DateDebut)} )`;
        if (!this.qDateService.IsNull(session.DateFin) && !this.qDateService.Compare(session.DateDebut, '=', session.DateFin))
          infoSession = `${session.Intitule} ( ${typeSession} du ${this.BuildDate(session.DateDebut)} au ${this.BuildDate(session.DateFin)} )`;
      }
      else if (session.IdentSession != '0' && session.IdentSession != '') {
        infoSession = `${session.Intitule} (Catalogue)`;
      }
    }

    return infoSession;

  }

  /*  CRUD LIGNE*/
  public CreateLigne(formation: ActionCoFormation, content: any) {
    if (formation.Code == 'DEFAULT') {
      // Formation DEFAULT Sur Mesure utilisé pour créer des lignes de devis hors catalogue
      let ligne: ActionCoLigneDevis = new ActionCoLigneDevis();
      ligne.StateLigne = CRUD.CREATE;
      ligne.IdentFormation = formation.Ident;
      this.model.CRUDActionCoLigneDevis = ligne;
      this.EditingLigne = this.EditingOption = -1;
      this.Newline = true;
      this.Editing = true;

      ligne.IdentAction = formation.ListAction[0].Ident;
      this.SelectChange(ligne.IdentAction, 'LIGNEACTION');
      if (formation.ListAction[0].ListSessionStage.length == 1 && formation.Code == 'DEFAULT') {
        const IdentSession: string = formation.ListAction[0].ListSessionStage[0].Ident;
        this.SelectChange(IdentSession, 'LIGNESESSION')
      }
    }
    else {
      this.listAction = formation.ListAction;
      if (this.listAction.length == 1) {
        // Creation automatique de la ligne de devis si la formation selectionnee ne contient qu'un produit
        this.listAction[0].Selected = true;
        this.CreateLigneAuto(formation.Ident);
      }
      else {
        // Ouverture d'une popup pour choisir le ou les produits de la formation delectionnee pour créer les lignes automatiquement
        this.modalService.open(content, { size: 'xl', windowClass: 'qmodalover', centered: true }).result.then((result) => {
          switch (result) {
            case 'CREATE':
              this.CreateLigneAuto(formation.Ident);
              break;
            case 'CANCEL': break;
          }
        });
      }
    }
  }

  public CreateLigneAuto(idFormation: string): void {

    this.model.ListActionCoParcours = new Array<ActionCoParcours>();
    if (this.listAction) {
      this.listAction.forEach(item => {
        if (item.Selected) {
          item.Selected = false;
          const parcours: ActionCoParcours = new ActionCoParcours();
          parcours.IdCatalogue = idFormation; //  formation.Ident;
          parcours.IdAction = item.Ident;
          parcours.IdSession = "0";
          //if (item.ListSessionStage.length > 0) {
          //  parcours.IdSession = item.ListSessionStage[0].IdentSession;
          //}
          parcours.IdStage = "0";
          parcours.IdReservation = "0";
          parcours.TypeStage = "";
          parcours.PrixUnitaire = item.PrixUnitaire;
          parcours.Quantite = item.Quantite;
          this.model.ListActionCoParcours.push(parcours);
        }
      });

      this.Editing = true;
      this.model.Mode = 'LIGNEDEVISAUTO';
      this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
        if (!data.HasError) {
          this.LoadedDevis = false;
          // this.model.Mode = 'INITDEVIS';
          this.actionCoService.GetInfoDevis(this.model).subscribe((data: ActionCoDevisModel) => {
            if (!data.HasError) {
              data.ListContact = this.model.ListContact;
              data.ListContactPrincipal = this.model.ListContactPrincipal;
              data.ActionCoFormation = this.model.ActionCoFormation;
              data.ActionCoTypeFormation = this.model.ActionCoTypeFormation;
              this.model = data;
              this.ReOrderLigneEtOption();
              this.actionCoService.CanTransform();
              this.LoadedDevis = true;
            }
          });
          this.actionCoService.OnDocumentDevis();
        }
        this.Editing = false;
      });
    }
  }

  public EditLigne(ligne: ActionCoLigneDevis, indexLine: number, indexOpt: number) {
    this.EditingLigne = indexLine;
    this.EditingOption = indexOpt;
    ligne.StateLigne = CRUD.UPDATE;
    this.TempLigne = { ...ligne };
    this.Editing = true;
  }

  private Clamp(val: number, min: number, max: number) {
    return (val < min) ? min : (val > max) ? max : val;
  }

  public SaveLigne(ligne: ActionCoLigneDevis) {
    if (this.model.Devis.DevisSigne || this.model.Devis.ReadOnly) {
      return;
    }
    //Verif champ obligatoire
    if (!ligne.IdentAction ||
      !ligne.GroupOption.id ||
      ligne.Quantite == undefined ||
      ligne.Quantite < 0 ||
      !ligne.Unite.id ||
      ligne.PrixUnitaire == undefined ||
      !ligne.TauxTVA.id
    ) {
      this.toast.showWarningToast('Veuillez renseigner les champs obligatoires');
      return;
    }

    ligne.GroupOption.id

    if (ligne.TypeRemise.id == 'POURCENT')
      ligne.Remise = this.Clamp(ligne.Remise, 0, 100);
    else if (ligne.TypeRemise.id == 'MONTANT')
      ligne.Remise = this.Clamp(ligne.Remise, 0, ligne.PrixUnitaire * ligne.Quantite);

    this.Newline = false;
    this.model.CRUDActionCoLigneDevis = ligne;
    if (this.model.CRUDActionCoLigneDevis.StateLigne == CRUD.CREATE) {
      this.model.CRUDActionCoLigneDevis.Ident = '0';

      let groupe: ActionCoLigneDevisOption | undefined = this.model.ListActionCoLigneDevisOption.find(option => option.CodeOption == ligne.GroupOption.id);
      if (groupe != undefined) {
        this.model.CRUDActionCoLigneDevis.OrdreLigne = groupe.ListActionCoLigneDevis.length;
      }
    }
    this.model.Mode = 'LIGNEDEVIS';
    this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
      if (!data.HasError) {
        this.model = data;
        this.ReOrderLigneEtOption();
        this.actionCoService.CanTransform();
        this.actionCoService.OnDocumentDevis();
      }
      this.Editing = false;
    });

    ligne.StateLigne = CRUD.READ;
  }
  public CancelLigne() {
    this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne] = { ...this.TempLigne };
    this.model.ListActionCoLigneDevisOption[this.EditingOption].ListActionCoLigneDevis[this.EditingLigne].StateLigne = CRUD.READ;
    this.Editing = false;
  }
  public CancelNewLigne() {
    this.model.CRUDActionCoLigneDevis = new ActionCoLigneDevis();
    this.Editing = false;
    this.Newline = false;
  }
  public DeleteLigne(ligne: ActionCoLigneDevis) {
    if (this.model.Devis.DevisSigne || this.model.Devis.ReadOnly) {
      return;
    }

    // Suppression de la ligne de devis
    this.Editing = true;
    this.model.CRUDActionCoLigneDevis = ligne;
    this.model.CRUDActionCoLigneDevis.StateLigne = CRUD.DELETE;
    this.model.Mode = 'LIGNEDEVIS';
    this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
      if (!data.HasError) {
        this.model = data;
        this.ReOrderLigneEtOption();
        this.actionCoService.CanTransform();
        this.actionCoService.OnDocumentDevis();
      }
      this.Editing = false;
    });
  }

  public DeleteAllLigne() {
    if (this.model.Devis.DevisSigne || this.model.Devis.ReadOnly || this.model.ListActionCoLigneDevisOption.length == 0) {
      return;
    }
    this.Editing = true;
    this.model.Mode = 'DELETEALLLIGNEDEVIS';
    this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
      if (!data.HasError) {
        this.model = data;
        this.actionCoService.CanTransform();
        this.actionCoService.OnDocumentDevis();
      }
      this.Editing = false;
    });


  }

  public GenererDevis() {
    if (this.model.Devis.DevisSigne || this.model.Devis.ReadOnly || this.SaveInprogress) {
      return;
    }
    if (!this.model.Devis.TypeDoc?.value) {
      this.toast.showWarningToast('veuillez renseigner un type de document.')
      return;
    }
    this.SaveInprogress = true;
    this.model.Mode = 'DEVIS';
    if (!this.model.Devis.Ident || this.model.Devis.Ident == '0') {
      this.model.Devis.StateDevis = CRUD.CREATE;
    } else {
      this.model.Devis.StateDevis = CRUD.UPDATE;
    }
    this.devisAwaitingGeneration = true;
    this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
      if (!data.HasError) {
        this.model = data;
        this.initBoInsertDoc();
        this.SaveInprogress = this.model.Devis.TypeDoc ? true : false;
        this.actionCoService.OnDevisSigned(this.model.Devis.DevisSigne);
        this.actionCoService.OnDevisCreated(this.model.Devis.Ident);
      }

      this.model.Mode = 'GENERERDOCDEVIS';
      this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.model).subscribe((data: ActionCoDevisModel) => {
        this.model.Devis.FileExist = data.Devis.FileExist;
        this.devisAwaitingGeneration = false;
        this.SaveInprogress = false;
        //pdf generer
        this.actionCoService.OnDocumentDevis();
        // this.indParam.showSplash(false);
        this.toast.showSuccessToast(`Le devis: ${this.model.Devis.Titre} a été générée.`);

        // mise à jour de l'historique
        this.historyService.GetHistory(this.actionCoService.Model.idActionCo).subscribe(() => { this.setIdActionCo.emit(this.model.ActionCo.Ident); });
        // Rechargement du modele apres la sauvegarde du devis
        this.actionCoService.GetInfoDevis(this.model).subscribe((data: ActionCoDevisModel) => {
          if (!data.HasError) {
            data.ActionCoFormation = this.model.ActionCoFormation;
            data.ActionCoTypeFormation = this.model.ActionCoTypeFormation;
            this.model = data;
            this.LoadedDevis = true;
          }
        });
      });
    });
  } 

  public UploadDevisWord() {
    const fileModel: FileModel = new FileModel();
    fileModel.Ident = this.model.Devis.Ident;
    fileModel.Extension = 'docx';
    fileModel.Name = this.model.Devis.Ident;
    fileModel.DownloadMode = 'DOCXGENERE';
    this.fileService.downloadFile(fileModel);
  }

  public UploadDevisPdf() {
    const fileModel: FileModel = new FileModel();
    fileModel.Ident = this.model.Devis.Ident;
    fileModel.Extension = 'pdf';
    fileModel.Name = this.model.Devis.Ident;
    fileModel.DownloadMode = 'DOCXGENERE';
    this.fileService.downloadFile(fileModel);
  }

  public CloseModalInsertDoc(success: boolean): void {
    if (success) {
      this.closeModalInsertDoc.nativeElement.click();
    }
  }


}


